module.exports = __webpack_public_path__ + "static/bg.adbee5b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/about-us/bg.svg
// module id = 3682
// module chunks = 168707334958949